export default function (to, from) {
  const lookbookRoutePart = 'lang-lookbook-orientation'
  const account = 'lang-account'

  // Do not scroll to top when navigating through lookbook or account
  if (
    (to.name.includes(account) && from.name.includes(account)) ||
    (to.name.includes(lookbookRoutePart) && from.name.includes(lookbookRoutePart))
  ) {
    return null
  }

  return { x: 0, y: 0 }
}
